const $ = window.jQuery;
const outfitClass = document.querySelector( '.outfit-wide' );
const fvcClass = document.querySelector( '.col--main' );
const jetsetterClass = document.querySelector( '.roundup-table-of-contents' );
const stClass = document.querySelector( '.single-post' );
const outfitModules = document.querySelectorAll( '.module.js-outfit' );
const outfitCarousels = document.querySelectorAll( '.outfit-carousel' );

$( () => {
	const slidesToShow = window.outfitSlidesToShow || {
		mobile: 1,
		tablet: 2,
		desktop: 3
	};

	if ( null !== outfitClass && null !== fvcClass ) {
		Object.assign( slidesToShow, {desktop: 2} );
	}

	if ( null !== outfitClass && null !== jetsetterClass ) {
		Object.assign( slidesToShow, {desktop: 2} );
	}

	if ( null !== outfitClass && null !== stClass ) {
		Object.assign( slidesToShow, {desktop: 2} );
	}

	if ( $.fn.slick ) {
		$( '.outfit-carousel' ).slick( {
			infinite: true,
			slidesToShow: slidesToShow.desktop,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: slidesToShow.tablet,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		} );
	}
} );

/**
 * Read More Read Less.
 *
 * @returns {void}
 */
const readmore = () => {
	const outfits = Array.from( document.querySelectorAll( '.js-outfit' ) );

	if ( !outfits ) {
		return;
	}

	const truncate = function( elem, introDescription, toggleButton ) {
		if ( !elem || !toggleButton ) {
			return;
		}

		const introTag = document.createElement( 'p' );
		const content = elem.textContent.trim();
		const dots = '...';
		const count = 35;
		let introContent = content.split( ' ' ).splice( 0, count );

		introContent = introContent.join( ' ' ) + dots;

		introTag.textContent = introContent;
		introTag.appendChild( toggleButton );

		introDescription.appendChild( introTag );
	};

	outfits.forEach( ( element ) => {
		const descContainer = element.querySelector( '.outfit-desc-content' );
		const introDescription = descContainer.querySelector( '.intro-description' );
		const introParagraph = descContainer.getElementsByTagName( 'p' );
		const fullDescription = descContainer.querySelector( '.full-description' );
		const toggleButton = descContainer.querySelector( '.toggle-content' );
		const paragraph = fullDescription.getElementsByTagName( 'p' );
		const lastParagraph = paragraph.length - 1;
		// If the first paragraph is empty, ignore it
		let firstParagraph;
		if ( paragraph.length ) {
			firstParagraph = paragraph[0].innerText ? paragraph[0] : 'object' === typeof paragraph[1] ? paragraph[1] : paragraph[0];
		}
		const DESCRIPTION_BLOCK_HEIGHT = 120;

		if ( null !== toggleButton && DESCRIPTION_BLOCK_HEIGHT < fullDescription.scrollHeight  ) {
			truncate( firstParagraph, introDescription, toggleButton );

			toggleButton.addEventListener( 'click', function() {
				const expanded = this.getAttribute( 'aria-expanded' );
				const toggleButtonText = this.querySelector( '.text' );
				let expaned;

				if ( 'true' === expanded ) {
					expaned = 'false';
					toggleButtonText.innerText = 'Read More';
					introDescription.classList.remove( 'visibility-hidden' );
					fullDescription.classList.add( 'visibility-hidden' );
					introParagraph[0].appendChild( toggleButton );
				} else {
					expaned = 'true';
					toggleButtonText.innerText = 'Read Less';
					fullDescription.classList.remove( 'visibility-hidden' );
					introDescription.classList.add( 'visibility-hidden' );
					paragraph[lastParagraph].appendChild( toggleButton );
				}

				this.setAttribute( 'aria-expanded', expaned );
			} );
		} else {
			fullDescription.classList.remove( 'visibility-hidden' );
			if ( toggleButton ) {
				toggleButton.classList.add( 'visibility-hidden' );
			}
		}
	} );
};

readmore();
